import * as React from 'react';
import { Redirect } from 'react-router';

const Error403: React.FC = () => <Redirect to='/forbidden' />;

export default Error403;
